export const LOCAL_STORAGE_ORDER_KEY = 'role_card_tags_order';
